const t = null;
export {
  t as default
};
//# sourceMappingURL=index.es269.js.map
